import { combineReducers } from "@reduxjs/toolkit";

import AppReducer from "./app";
import LoaderReducer from "./loaders";

export default combineReducers({
    globalState: AppReducer,
    loaders: LoaderReducer,
});
